module.exports = __webpack_public_path__ + "img/1.0e89e4e3.gif";